import { h, FunctionalComponent, render } from "preact";

import { useContext, useState } from 'preact/hooks';

import { SwiperSlide } from 'swiper/react'

import { Carousel } from "../../../components/Carousel";
import { CallToActionButton } from "../../../components/CallToActionButton";
import { DelYeahContainer } from "../../../containers/DelYeahContainer";
import { CloseIcon } from "../../../icons/Close";
import { RewardServiceContext, OfferServiceContext } from "@authentic/loyalty-pwa/providers";
import { useEffect } from "react";
import {Reward, Offer, OfferResponse, OfferServiceInterface, OffersQuery} from "@authentic/loyalty-pwa/interfaces";
import { RewardsPointsWidget, TierWidgetType } from '../../../components/tier-widget/RewardsPointsWidget';
import { CTAWidget } from '../../../components/CTAWidget';
import { UserProvider, useUser } from "@authentic/loyalty-pwa/providers";
import { LayoutStyled, ModalContentStyled, ModalOverlayStyled, ModalStyled, RewardDetailStyled, RewardsWidgetWrapper } from "./your-rewards.style";

import { TabItemContent, TabItemTitle, Tabs } from "./tabs";
import { ItemType, OfferStatus, RewardOfferItemI, RewardStatus } from "./reward-offer-item.types";
import { RewardOfferItem } from "./reward-offer-item";
import { Snackbar, SnackbarType } from "../../../components/snackbar/snackbar";
import { link } from "@authentic/loyalty-pwa/util";

let rewards: RewardOfferItemI[] = [];

let offers: RewardOfferItemI[] = [];

export const DelYeahYourRewards: FunctionalComponent = () => {
  const [itemTabSelected, setItemTabSelected] = useState(1);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarType, setSnackbarType] = useState(SnackbarType.Success);

  const rewardsService = useContext(RewardServiceContext);
  const offersService = useContext(OfferServiceContext);
  const [rewardsPage, setRewardsPage] = useState(1);
  const [offersPage, setOffersPage] = useState(1);
  const [showRewards, setShowRewards] = useState(false);
  const [isRewardTapForDetailsHitted, setIsRewardTapForDetailsHitted] = useState(false);
  const [showOffers, setShowOffers] = useState(false);
  const [isOfferTapForDetailsHitted, setIsOfferTapForDetailsHitted] = useState(false);
  const [rewardList, setRewardList] = useState<RewardOfferItemI[]>(rewards);
  const [offerList, setOfferList] = useState<RewardOfferItemI[]>(offers);
  const [isSavingOffer, setIsSavingOffer] = useState(false);
  const [isRedeemingReward, setIsRedeemingReward] = useState(false);
  const [isModalActive, setIsModalActive] = useState(false);
  const [rewardIndexSelected, setRewardIndexSelected] = useState(-1);
  const [offerIndexSelected, setOfferIndexSelected] = useState(-1);
  const htmlTitle: string = 'Your Del Yeah! Rewards';
  const htmlMetaDescription: string = 'Your Del Yeah! Rewards Dashboard of available rewards and offers.';
  const IDItemMenuSelected: string = '2';
  const getRewardsErrorMessage: string = 'There was an error to get rewards.';
  const getOffersErrorMessage: string = 'There was an error to get offers.';

  const resetUserSummaryData = () => {
    UserProvider.get().summaryReset();
  };

  const user = useUser();

  useEffect(() => {
    offers = [];
    offersService?.getOffers({
      page: 1,
      results_per_page: 100,
      sort_by: 'asc',
      category: 'mobile_offers',
      has_processing_status: 'pending,clipped',
    } as OffersQuery).then((e) => {
      if(e.success && e.offers){
        e.offers?.map((offer: Offer) => {
          offers.push({
            id: offer.id,
            leftImageUrl: offer.thumbnail_url,
            topTitle: offer.subtitle || 'FREE',
            bottomTitle: offer.title,
            callToActionText: 'Tap for details',
            status: offer.respondable ? OfferStatus.Active : OfferStatus.Saved,
            expirationDate: (offer.end_date) ? new Date(offer.end_date) : undefined,
            detail: offer.content
          })
        });
        setOfferList(offers);
        setShowOffers(true);
      } else{
        setSnackbarMessage(user.offers?.error?.message || getOffersErrorMessage);
        setSnackbarType(SnackbarType.Error);
        setOpenSnackbar(true);
      }

    })
  }, [offersPage]);

  const loadMoreRewards = () => {
    setRewardsPage(rewardsPage + 1);
  };

  useEffect(() => {
    rewards = [];

    if (user.mobile_rewards?.success && user.mobile_rewards?.rewards) {
      user.mobile_rewards?.rewards.map((reward) => {
        let status = RewardStatus.Active;
        if (!reward.redeemable) {
          // Required minimun tier not met
          if (reward.respondable_info.code === '4405') {
            status = RewardStatus.Locked;
          }

          // You have reached the maximum limit of responses per user
          if (reward.respondable_info.code === '4402') {
            status = RewardStatus.Redeemed;
          }

          // Locked Rewards: Required metric not met
          if (reward.respondable_info.code === '4404') {
            status = RewardStatus.Locked;
          }

          // Redeemed Rewards: Max Limit has been reached
          if (reward.respondable_info.code === '4403') {
            status = RewardStatus.Redeemed;
          }
        }
        rewards.push({
          id: reward.id,
          leftImageUrl: reward.thumbnail_url,
          topTitle: (parseInt(reward.points, 10) === 0) ? 'FREE TACO' : `${reward.points} PTS`,
          bottomTitle: reward.title,
          callToActionText: 'Tap for details',
          status: status,
          expirationDate: (reward.end_date) ? new Date(reward.end_date) : undefined,
          detail: reward.content
        });

        setRewardList(rewards);
        setShowRewards(true);
      });
    } else {
      setSnackbarMessage(user.rewards?.error?.message || getRewardsErrorMessage);
      setSnackbarType(SnackbarType.Error);
      setOpenSnackbar(true);
    }
  }, [rewardsPage]);

  const modalToggle = (e: any) => {
    if (isModalActive) {
      hideModal();
    } else {
      setIsModalActive(true);
    }
  };

  const openRedeemingDetailModal = (data: any) => {
    setIsRewardTapForDetailsHitted(false);
    setRewardIndexSelected(rewards.findIndex((item) => item.id === data.id));
    setIsModalActive(true);
  };

  const openRewardDetail = (data: any) => {
    setRewardIndexSelected(rewards.findIndex((item) => item.id === data.id));
    setIsRewardTapForDetailsHitted(true);
    setIsModalActive(true);
  };

  const redeemReward = () => {
    setIsRedeemingReward(true);
    rewardsService?.redeemReward(rewards[rewardIndexSelected].id)
      .then((res: any) => {
        setIsRedeemingReward(false);
        hideModal();
        if (res.success) {
          rewards[rewardIndexSelected].status = RewardStatus.Redeemed;
          resetUserSummaryData();
        }
        handleResponse(res);
      });
  };

  const redeemRewardFromDetailModal = () => {
    setIsRewardTapForDetailsHitted(false);
    setIsModalActive(false);

    setTimeout(() => {
      setIsModalActive(true);
    }, 100);
  }

  const saveOfferFromDetailModal = () => {
    setIsOfferTapForDetailsHitted(false);
    setIsModalActive(false);

    setTimeout(() => {
      setIsModalActive(true);
    }, 100);
  }

  const openSavingDetailModal = (data: any) => {
    setIsOfferTapForDetailsHitted(false);
    setOfferIndexSelected(offers.findIndex((item) => item.id === data.id));
    setIsModalActive(true);
  };

  const openOfferDetail = (data: any) => {
    setOfferIndexSelected(offers.findIndex((item) => item.id === data.id));
    setIsOfferTapForDetailsHitted(true);
    setIsModalActive(true);
  };

  const useOffer = () => {
    setIsSavingOffer(true);
    offersService?.saveOffer(offers[offerIndexSelected].id)
      .then((res: any) => {
        setIsSavingOffer(false);
        hideModal();
        if (res.success) {
          offers[offerIndexSelected].status = OfferStatus.Saved;
        }
        handleResponse(res);
      });
  };

  const hideModal = () => {
    setIsOfferTapForDetailsHitted(isRewardTapForDetailsHitted);
    setIsRewardTapForDetailsHitted(false);
    setIsModalActive(false);
    setRewardIndexSelected(-1);
    setOfferIndexSelected(-1);
  };

  const callbackTabItemOnClick = (tabId: number, e: any) => {
    console.log('callbackTabItemOnClick: ', tabId);
    setItemTabSelected(tabId);
  };

  const callbackOnCloseSnackbar = () => {
    setOpenSnackbar(false);
    console.log('callbackOnCloseSnackbar...');
  };

  const handleResponse = (res: any) => {
    if (res.message) {
      if (res.success) {
        setSnackbarType(SnackbarType.Success);
      } else {
        setSnackbarType(SnackbarType.Error);
      }
      setSnackbarMessage(res.message);
      setOpenSnackbar(true);
    }
  }

  return (
    <DelYeahContainer htmlTitle={htmlTitle} htmlMetaDescription={htmlMetaDescription} IDItemMenuSelected={IDItemMenuSelected}>
      <RewardsWidgetWrapper>
        <RewardsPointsWidget type={TierWidgetType.FULL} />
      </RewardsWidgetWrapper>

      <Tabs>
        <TabItemTitle isActive={(itemTabSelected === 1)} callbackOnClick={callbackTabItemOnClick.bind(this, 1)} title={'Your Rewards'}></TabItemTitle>
        <TabItemTitle isActive={(itemTabSelected === 2)} callbackOnClick={callbackTabItemOnClick.bind(this, 2)} title={'Your Offers'}></TabItemTitle>

        {showRewards && (
          <TabItemContent isActive={(itemTabSelected === 1)}>
            <p>Redeem available rewards to load and use at checkout.</p>
            {rewardList?.map((item: RewardOfferItemI) => (
              <RewardOfferItem
                rewardOfferItem={item}
                callbackTapForDetails={openRewardDetail}
                openModal={openRedeemingDetailModal}
                itemType={ItemType.Reward}></RewardOfferItem>
            ))}
          </TabItemContent>
        )}

        {showOffers && (
          <TabItemContent isActive={(itemTabSelected === 2)}>
            <p>Save qualifying offers to load and use at checkout.</p>
            {offerList?.map((item: RewardOfferItemI) => (
              <RewardOfferItem
                rewardOfferItem={item}
                callbackTapForDetails={openOfferDetail}
                openModal={openSavingDetailModal}
                itemType={ItemType.Offer}></RewardOfferItem>
            ))}
          </TabItemContent>
        )}
      </Tabs>

      <LayoutStyled>
        <h2>Your Rewards</h2>
        <p>Redeem available rewards to load and use at checkout.</p>

        {showRewards && (
          <Carousel indexCarouselRef={1} spaceBetween={12}>
            {rewardList?.map((item: RewardOfferItemI) => (
              <SwiperSlide>
                <RewardOfferItem
                  rewardOfferItem={item}
                  callbackTapForDetails={openRewardDetail}
                  openModal={openRedeemingDetailModal}
                  itemType={ItemType.Reward}></RewardOfferItem>
              </SwiperSlide>
            ))}
          </Carousel>
        )}

        <h2> Your Offers</h2>
        <p>Save qualifying offers to load and use at checkout.</p>

        {showOffers && (
          <Carousel indexCarouselRef={2} spaceBetween={12}>
            {offerList?.map((item: RewardOfferItemI) => (
              <SwiperSlide>
                <RewardOfferItem
                  rewardOfferItem={item}
                  callbackTapForDetails={openOfferDetail}
                  openModal={openSavingDetailModal}
                  itemType={ItemType.Offer}></RewardOfferItem>
              </SwiperSlide>
            ))}
          </Carousel>
        )}
      </LayoutStyled>

      {isModalActive && rewardIndexSelected > -1 && (
        <ModalStyled className={(isModalActive ? 'revealing' : 'revealing out')}>
          <ModalContentStyled className="modal-content">

            <RewardDetailStyled>
              <span class="modal-close-button" onClick={modalToggle}><CloseIcon></CloseIcon></span>

              <img src={rewardList[rewardIndexSelected].leftImageUrl} />

              {isRewardTapForDetailsHitted && (
                <div>
                  <span class="title" dangerouslySetInnerHTML={{
                    __html: rewardList[rewardIndexSelected].bottomTitle
                  }}></span>
                  {rewardList[rewardIndexSelected].expirationDate && (
                    <span class="subtitle">EXPIRES {rewardList[rewardIndexSelected].expirationDate}</span>
                  )}
                  <p class="description" dangerouslySetInnerHTML={{
                    __html: rewardList[rewardIndexSelected].detail
                  }}></p>
                  <CallToActionButton onClick={redeemRewardFromDetailModal} disabled={rewardList[rewardIndexSelected].status === RewardStatus.Redeemed}>
                    Redeem Reward
                  </CallToActionButton>
                </div>
              )}

              {!isRewardTapForDetailsHitted && (
                <div>
                  <span class="title">Are you sure?</span>
                  <p class="description">Once you redeem a reward, your points will be deducted and you will have 30 days to apply it towards an order.</p>
                  <CallToActionButton onClick={redeemReward} disabled={isRedeemingReward}>
                    Yes I am sure
                  </CallToActionButton>
                  <a class="link-button" onClick={modalToggle}>Not now</a>
                </div>
              )}
            </RewardDetailStyled>

          </ModalContentStyled>
          <ModalOverlayStyled className="modal-overlay"></ModalOverlayStyled>
        </ModalStyled>
      )}

      {isModalActive && offerIndexSelected > -1 && (
        <ModalStyled className={(isModalActive ? 'revealing' : 'revealing out')}>
          <ModalContentStyled className="modal-content">

            <RewardDetailStyled>
              <span class="modal-close-button" onClick={modalToggle}><CloseIcon></CloseIcon></span>

              <img src={offerList[offerIndexSelected].leftImageUrl} />

              {isOfferTapForDetailsHitted && (
                <div>
                  <span class="title" dangerouslySetInnerHTML={{
                    __html: offerList[offerIndexSelected].bottomTitle
                  }}></span>
                  {offerList[offerIndexSelected].expirationDate && (
                    <span class="subtitle">EXPIRES {offerList[offerIndexSelected].expirationDate}</span>
                  )}

                  <p class="description" dangerouslySetInnerHTML={{
                    __html: offerList[offerIndexSelected].detail
                  }}></p>

                  <CallToActionButton onClick={saveOfferFromDetailModal} disabled={offerList[offerIndexSelected].status === OfferStatus.Saved}>
                    Save Offer
                  </CallToActionButton>
                </div>
              )}

              {!isOfferTapForDetailsHitted && (
                <div>
                  <span class="title">Are you sure you want to save this offer?</span>
                  {offerList[offerIndexSelected].expirationDate && (
                    <span class="subtitle">EXPIRES {offerList[offerIndexSelected].expirationDate}</span>
                  )}

                  <p class="description">Once you save an offer, you will have a set amount of time to use it. You can not undo saving an offer.</p>

                  <CallToActionButton onClick={useOffer} disabled={isSavingOffer}>
                    Save Offer
                  </CallToActionButton>
                  <a class="link-button" onClick={modalToggle}>Not now</a>
                </div>
              )}
            </RewardDetailStyled>

          </ModalContentStyled>
          <ModalOverlayStyled className="modal-overlay"></ModalOverlayStyled>
        </ModalStyled>
      )}
      <CTAWidget url={link('/scan-code')} />
      <Snackbar
        message={snackbarMessage}
        isActive={openSnackbar}
        type={snackbarType}
        timeout={6000}
        callbackOnClose={callbackOnCloseSnackbar}></Snackbar>
    </DelYeahContainer >
  )
}
